module.exports = __webpack_public_path__ + "static/media/rotation.ec4e4791.svg";